import(/* webpackMode: "eager", webpackExports: ["RoleChapter","OtherRolesSection","HowToApplySection"] */ "/opt/buildhome/repo/apps/web/src/components-pages/Careers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/ContentIdeaPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/ImageTextSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/PageSchemas.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/ProcessSteps.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/StructuredData.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/common/UniversalPageHero.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/src/components/services/ConsultationCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/services/ServiceBenefitItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/services/ServiceFaq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/services/ServiceFeatureCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/services/ServiceInfoBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/services/ServicePageLayout.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/src/components/services/ServicePageTransition.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/services/ServiceSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/apps/web/src/components/services/ServiceStepList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
